import BingoTimerRedux from './bingo_timer_redux';

export default BingoTimerRedux;
